import deepmerge from "deepmerge";

export default {
    LOGIN(state, payload) {
        localStorage.setItem('login', JSON.stringify(payload));
        state.login = payload;
    },
    REQUESTS(state, start) {
        if (start == true) { state.requests += 1; }
        else { state.requests -= 1; }
    },
    NAMESPACE(state, data) {
        state.namespace = deepmerge(state.namespace, data)
    }
}